import { commitMutation, graphql } from 'react-relay';
import type { Environment } from 'relay-runtime';

const mutation = graphql `
    mutation SubscriptionMutation(
        $input: UpdateSubscriptionsInput!
        $salesAdmission: String!
        $retailOnly: Boolean!
    ) {
        subscriptions(input: $input) {
            subscriptionManager {
                id
                ... on SubscriptionManager {
                    subscriptiontable(salesAdmission: $salesAdmission, retailOnly: $retailOnly) {
                        id
                        ...AboTable_table
                    }
                    priceinfo(salesAdmission: $salesAdmission) {
                        id
                        checked
                        ...PriceInfo_component
                    }
                }
            }
        }
    }
`;

interface SubscriptionMutationInput {
    subscriptionManagerId: string;
    data: {
        documentsSubscribed?: Array<any>;
        priceInfoSubscribed?: boolean;
        preferredLanguage?: string;
        country: string;
        retailOnly: boolean;
    };
}

export function commitSubscriptionMutation(
    environment: Environment,
    input: SubscriptionMutationInput,
    onSuccess: () => void,
    onFailure: () => void
) {
    const variables = {
        input: {
            subscriptionManagerId: input.subscriptionManagerId,
            data: {
                ...input.data,
                country: input.data.country.toUpperCase(),
            },
        },
        salesAdmission: input.data.country.toUpperCase(),
        retailOnly: input.data.retailOnly,
    };

    commitMutation( environment, {
        mutation,
        variables,
        onCompleted: ( response, errors ) => {
            if ( errors ) {
                onFailure();
            } else {
                onSuccess();
            }
        },
        onError: () => {
            onFailure();
        },
    } );
}


// LEGACY CODE ---- vvv
// import * as Relay from 'react-relay';
// interface SubscriptionMutationProps {
//     subscriptionManagerId : string;
//     data : {
//         documentsSubscribed? : Array<any>,
//         priceInfoSubscribed? : boolean,
//         preferredLanguage? : string,
//         country : string;
//         retailOnly : boolean;
//     };
// }


// class SubscriptionMutation extends Relay.Mutation<SubscriptionMutationProps, any> {
//     getMutation() {
//         return Relay.QL`mutation {subscriptions}`;
//     }

//     getVariables() {
//         const data = {
//             ...this.props.data,
//             country: this.props.data.country.toUpperCase(),
//         };
//         return {
//             data,
//             subscriptionManagerId: this.props.subscriptionManagerId,
//         };
//     }

//     getFatQuery() {
//         return Relay.QL`
// 			fragment on UpdateSubscriptionsPayload {
// 				subscriptionManager
// 			}
// 		`;
//     }

//     getConfigs() {
//         return [ {
//             type: 'FIELDS_CHANGE',
//             fieldIDs: {
//                 subscriptionManager: this.props.subscriptionManagerId,
//             },
//         } ];
//     }
// }

// export { SubscriptionMutation as default };
